import { render, staticRenderFns } from "./AdmitCardSearch.vue?vue&type=template&id=675a1f45&"
import script from "./AdmitCardSearch.vue?vue&type=script&lang=js&"
export * from "./AdmitCardSearch.vue?vue&type=script&lang=js&"
import style0 from "./AdmitCardSearch.vue?vue&type=style&index=0&id=675a1f45&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports